import { Globe, Menu, X } from "lucide-react"
import TaskPill from "@/components/TaskPill"
import NotificationBell from "@/components/layout/NotificationBell"
import UserMenu from "@/components/layout/UserMenu"
import type { Market } from "@/lib/useMarket"
import MarketSelect from "../../Sidebar/components/MarketSelect"
import ProductSearch from "../../Sidebar/components/ProductSearch"
import type { NavPage } from "../topNavData"

type Props = {
  page: NavPage
  menuOpen: boolean
  onMenuToggle: () => void
  markets: Market[]
  market: Market | null
  onMarketChange: (market: Market | null) => void
}

// The only navigation: Menu button, then today's top bar (market filter,
// product search, tasks, bell, avatar). The page title and group tabs below
// show where you are.
export default function TopBar({ page, menuOpen, onMenuToggle, markets, market, onMarketChange }: Props) {
  const block =
    page.scope === "market" || page.scope === "either" ? (
      <MarketSelect markets={markets} value={market} onChange={onMarketChange} allowAll={page.scope === "either"} />
    ) : page.scope === "all" ? (
      <div className="flex h-full min-w-[180px] items-center gap-2 border-r border-border bg-muted/60 px-4 text-[13px] font-medium text-foreground">
        <Globe size={15} />
        All markets
      </div>
    ) : null

  return (
    <div className="relative z-40 flex h-11 flex-shrink-0 items-stretch border-b border-border bg-background">
      <button
        type="button"
        onClick={onMenuToggle}
        aria-expanded={menuOpen}
        className={`flex h-full items-center gap-2 border-r border-border px-4 text-sm font-semibold transition-colors ${
          menuOpen ? "bg-primary/10 text-primary" : "text-foreground hover:bg-muted"
        }`}
      >
        {menuOpen ? <X size={16} strokeWidth={2.25} /> : <Menu size={16} strokeWidth={2.25} />}
        {menuOpen ? "Close" : "Menu"}
      </button>

      {block}
      <ProductSearch />
      <div className="flex items-center gap-2 px-3">
        <TaskPill />
        <NotificationBell />
        <UserMenu />
      </div>
    </div>
  )
}
